var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.app)?_c('bs-container',{attrs:{"app":_vm.app,"tag":_vm.tag}},[_c('div',{staticClass:"md-content-wrap"},[_vm._t("default")],2)]):_c(_vm.tag,{tag:"div",staticClass:"md-content-wrap"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }